export const ProductApiConstants = {
  QUERY_PARAMS: {
    FL: 'id, sku_id, sku_code, availability, availability_status, url, description, sku, SellingSkuCode, look, pid, collection_name, style_name, style_number, color_number, sku_color, color_code, color_name, product_type, construction, constructiontype, segment, Installation, Color, Thickness, ProductSize, Price, Sustainability, installation_methods, InstallMethod, manufacturer_url, thumb_image, swatch_images, swatch_url_images, room_scene, APPVisualizer, Resources, ActualWidth, ActualLength, procurement, producturl, skuIntroductionDate, feature, flooring_type, product_line, sqft_carton, edge_treatment, plank_width, plank_length, color_family, composition, surface_texture, finish, shade, species, installation_level, item_number, Decor_Type, wear_layer, technology, room, Retailer, pdpURL, BrandSiteName, ProductClassification, searchableFlag, type, attached_pad, gauge, recommendedAdhesive, seamingMethod, flexibility, coefficientOfFriction, country_origin, quickShip, classification, productLaunchDate',
    PLP_FL:
      'id, pid, style_name, style_number, construction, constructiontype, room_scene, product_type, manufacturer_url, quickShip, thumb_image, swatch_images, swatch_url_images, collection_name, productSize, title, sizecode, color_code, color_name, sku_code, productLaunchDate',
    SEARCH_FL:
      'id, pid, manufacturer_url, style_name, style_number, color_code, color_name, collection_name, ProductClassification, title, productSize, sizecode, productLaunchDate'
  },
  // TODO: Please update SHORT, LONG, ALL in sync
  FILTER_KEY_MAP: {
    SHORT_KEYS: {
      searchType: 'qt',
      styleNumber: 'sn',
      sizecode: 'sc',
      colors: 'c',
      color_family: 'cf',
      product_type: 'pt',
      fiber_type: 'ft',
      backing_type: 'bt',
      surface_appearance: 'sa',
      dye_method: 'dm',
      face_weight: 'fw',
      productSize: 'ps',
      quickShip: 'qs',
      construction: 'con',
      constructiontype: 'ct',
      installation_methods: 'im',
      wear_layer: 'wl',
      thickness: 'th',
      ProductClassification: 'pc',
      Installation: 'i'
    } as Record<string, string>,
    LONG_KEYS: {
      qt: 'searchType',
      sn: 'styleNumber',
      sc: 'sizecode',
      c: 'colors',
      cf: 'color_family',
      pt: 'product_type',
      ft: 'fiber_type',
      bt: 'backing_type',
      sa: 'surface_appearance',
      dm: 'dye_method',
      fw: 'face_weight',
      ps: 'productSize',
      qs: 'quickShip',
      con: 'construction',
      ct: 'constructiontype',
      im: 'installation_methods',
      wl: 'wear_layer',
      th: 'thickness',
      pc: 'ProductClassification',
      i: 'Installation'
    } as Record<string, string>,
    ALL_SHORT_KEYS: [
      'qt',
      'sn',
      'sc',
      'c',
      'cf',
      'pt',
      'ft',
      'bt',
      'sa',
      'dm',
      'fw',
      'ps',
      'qs',
      'con',
      'ct',
      'im',
      'wl',
      'th',
      'pc',
      'i'
    ],
    NOT_ALLOWED_IN_PLP: ['sn', 'sc']
  }
};
